webpackJsonp([237],{

/***/ 1301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingKnowledgeTable_vue__ = __webpack_require__(3064);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12637208_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingKnowledgeTable_vue__ = __webpack_require__(5693);
function injectStyle (ssrContext) {
  __webpack_require__(5691)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12637208"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingKnowledgeTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12637208_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingKnowledgeTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* unused harmony export trimParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeEmptyParams;
/* harmony export (immutable) */ __webpack_exports__["d"] = setParams;
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* harmony export (immutable) */ __webpack_exports__["a"] = conveSomeDataType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSeachParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query);
        // 设置搜索参数
        vm.setSearchParams(queryParams);
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSeachParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSeachParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      params[key] = newParams[key];
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1515:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getExel */
/* unused harmony export getExelByPost */
/* harmony export (immutable) */ __webpack_exports__["a"] = NumberArray;
/* unused harmony export StringArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var base = window._env_.VUE_APP_HOST;
function getExel(url, params) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var data = {
      method: 'GET',
      url: base + url,
      headers: {
        Authorization: localStorage.getItem('tokenType') + ' ' + localStorage.getItem('token'),
        'Authorization-Guard': localStorage.getItem('guard')
      },
      responseType: 'arraybuffer',
      params: params
    };
    resolve(__WEBPACK_IMPORTED_MODULE_1_axios___default()(data));
  });
}
function getExelByPost(url, params) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var data = {
      method: 'post',
      url: base + url,
      data: params,
      headers: {
        Authorization: localStorage.getItem('tokenType') + ' ' + localStorage.getItem('token'),
        'Authorization-Guard': localStorage.getItem('guard')
      },
      responseType: 'arraybuffer'
    };
    resolve(__WEBPACK_IMPORTED_MODULE_1_axios___default()(data));
  });
}

// 将字符串数组转换为数字数组
function NumberArray(value) {
  var valueArray = Array.isArray(value) ? value : [value];
  return valueArray.map(function (item) {
    return Number(item);
  });
}

function StringArray(value) {
  // 如果 value 不是数组，则将其转换成数组
  var valueArray = Array.isArray(value) ? value : [value];
  return valueArray.map(function (item) {
    return String(item);
  });
}

/***/ }),

/***/ 1518:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      instructionGroups: []
    };
  },

  methods: {
    loadGroups: function loadGroups() {
      var _this = this;

      request.page('queryTrainingInstructionGroupAll').then(function (_ref) {
        var data = _ref.data;

        _this.instructionGroups = data.map(function (it) {
          return { value: it.id, label: it.name };
        });
      });
    },
    deleteInstructionGroup: function deleteInstructionGroup(item) {
      var _this2 = this;

      this.$confirm('\u786E\u8BA4\u5220\u9664\u5206\u7EC4\u300C' + item.label + '\u300D\u5417\uFF1F', '提示', { type: 'warning' }).then(function () {
        return request.common('deleteTrainingInstructionGroup', item.value);
      }).then(function () {
        _this2.$message.success('删除成功');
        _this2.onInstructionGroupDeleted(item);
        _this2.loadGroups();
      }).catch(function () {});
    },
    onInstructionGroupDeleted: function onInstructionGroupDeleted(item) {
      if (this.form && this.form.instruction_group_name === item.label) {
        this.form.instruction_group_name = null;
      }
      if (this.search && Number(this.search.instruction_group_id) === Number(item.value)) {
        this.search.instruction_group_id = null;
      }
    },
    getOptionLabel: function getOptionLabel(optType, val) {
      var type = this.options[optType].find(function (one) {
        return one.value === val;
      });
      return type ? type.label : '';
    }
  }
});

/***/ }),

/***/ 1613:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSuperAdminUser;
function isSuperAdminUser(user) {
  return Number(user && user.usertype) === 1;
}

/***/ }),

/***/ 2119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return options; });
/* harmony export (immutable) */ __webpack_exports__["b"] = isKnowledgeDialogEditLocked;
// initial state

var consts = {
  // 布尔值
  FALSE: 0,
  TRUE: 1,

  // 是否通用
  IS_COMMON_DEDICATED: 0,
  IS_COMMON_SHARED: 1,

  // 激活状态
  STATUS_NEW: 1,
  // 如要修改，请同步修改training-course.constants.js中的KNOWLEDGE_STATUS_ACTIVE常量
  STATUS_ACTIVE: 2,
  STATUS_BANNED: 3
};
var options = {
  IsCommonStatus: [{ value: consts.IS_COMMON_SHARED, label: '通用' }, { value: consts.IS_COMMON_DEDICATED, label: '专用' }],
  KnowledgeStatus: [{ value: consts.STATUS_ACTIVE, label: '已激活' }, { value: consts.STATUS_BANNED, label: '已作废' }],
  KnowledgeStatusTable: [{ value: consts.STATUS_NEW, label: '新创建' }, { value: consts.STATUS_ACTIVE, label: '已激活' }, { value: consts.STATUS_BANNED, label: '已作废' }]
};

function isKnowledgeDialogEditLocked(id, status) {
  return Number(id) > 0 && Number(status) !== consts.STATUS_NEW;
}

/***/ }),

/***/ 3064:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_mixins_table__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_training_training_mixins__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_training_training_user__ = __webpack_require__(1613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_training_training_knowledge_constants__ = __webpack_require__(2119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_common__ = __webpack_require__(1515);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__core_mixins_table__["b" /* default */], __WEBPACK_IMPORTED_MODULE_2__views_training_training_mixins__["a" /* default */]],
  components: {},
  data: function data() {
    var _this = this;

    return {
      options: __WEBPACK_IMPORTED_MODULE_4__views_training_training_knowledge_constants__["c" /* options */],
      consts: __WEBPACK_IMPORTED_MODULE_4__views_training_training_knowledge_constants__["a" /* consts */],
      search: {
        created_at: [],
        status: null,
        is_common: null,
        creator_id: [],
        name: null,
        customerid: []
      },
      searchFieldType: {
        status: Number,
        is_common: Number,
        customerid: Array,
        creator_id: __WEBPACK_IMPORTED_MODULE_5__utils_common__["a" /* NumberArray */],
        created_at: Array
      },
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      dialogTitle: '',
      dialogVisible: false,
      dialogId: 0,
      dialogStatus: __WEBPACK_IMPORTED_MODULE_4__views_training_training_knowledge_constants__["a" /* consts */].STATUS_NEW,
      refreshAfterDialogClose: false,
      dialogForm: {
        name: '',
        is_common: 1,
        customerid: null
      },
      dialogRules: {
        name: [{ required: true, message: '请输入知识库名称', trigger: 'blur' }],
        is_common: [{ required: true, message: '请选择是否通用', trigger: 'change' }],
        customerid: [{
          validator: function validator(rule, value, callback) {
            if (Number(_this.dialogForm.is_common) === 0 && !value) {
              callback(new Error('请选择客户'));
              return;
            }
            callback();
          },
          trigger: 'change'
        }]
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    loginUser: function loginUser(state) {
      return state.login.user || {};
    }
  }), {
    isSuperAdmin: function isSuperAdmin() {
      return Object(__WEBPACK_IMPORTED_MODULE_3__views_training_training_user__["a" /* isSuperAdminUser */])(this.loginUser);
    },
    isDialogEditLocked: function isDialogEditLocked() {
      return Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_knowledge_constants__["b" /* isKnowledgeDialogEditLocked */])(this.dialogId, this.dialogStatus);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, request.map(['getPlatformUsersDetail', 'getPlatformUsersIndex', 'getCustomerTable', 'getCustomerDetail', 'getTrainingKnowledgeDetail']), {
    /**
     * 获得表格数据
     * @param {*} params
     *
     */
    getTableData: function getTableData(params) {
      return request.page('getTrainingKnowledgeTable', params);
    },
    createTrainingKnowledge: function createTrainingKnowledge() {
      this.dialogTitle = '新增知识库';
      this.dialogId = 0;
      this.dialogStatus = __WEBPACK_IMPORTED_MODULE_4__views_training_training_knowledge_constants__["a" /* consts */].STATUS_NEW;
      this.refreshAfterDialogClose = false;
      this.resetDialogForm();
      this.dialogVisible = true;
    },
    editTrainingKnowledge: function editTrainingKnowledge(id) {
      var _this2 = this;

      request.loading('getTrainingKnowledgeDetail', { id: id }).then(function (_ref) {
        var data = _ref.data;

        _this2.dialogTitle = '修改知识库';
        _this2.dialogId = id * 1;
        _this2.dialogStatus = Number(data.status) || __WEBPACK_IMPORTED_MODULE_4__views_training_training_knowledge_constants__["a" /* consts */].STATUS_NEW;
        _this2.dialogForm = {
          name: data.name,
          is_common: Number(data.is_common),
          customerid: data.customerid ? String(data.customerid) : null
        };
        _this2.dialogVisible = true;
        _this2.handleDialogIsCommonChange(_this2.dialogForm.is_common);
      });
    },
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    },
    closeDialog: function closeDialog() {
      this.refreshAfterDialogClose = false;
      this.dialogVisible = false;
    },
    closeDialogRefresh: function closeDialogRefresh() {
      this.refreshAfterDialogClose = true;
      this.dialogVisible = false;
    },
    changeTrainingKnowledgeStatus: function changeTrainingKnowledgeStatus(row) {
      var _this3 = this;

      var isActive = Number(row.status) === __WEBPACK_IMPORTED_MODULE_4__views_training_training_knowledge_constants__["a" /* consts */].STATUS_ACTIVE;
      var actionText = isActive ? '作废' : '激活';
      var successText = isActive ? '作废成功' : '激活成功';
      var apiName = isActive ? 'banTrainingKnowledge' : 'activeTrainingKnowledge';
      var message = isActive ? '\u786E\u5B9A\u8981' + actionText + '\u77E5\u8BC6\u5E93\u3010' + row.name + '\u3011\u5417\uFF1F\u4F5C\u5E9F\u540E\u8BE5\u77E5\u8BC6\u5E93\u4E0D\u4F1A\u4ECE\u5DF2\u6709\u5173\u8054\u4E2D\u79FB\u9664\uFF0C\u4F46\u521B\u5EFA\u65B0\u8D44\u6E90\u65F6\u4E0D\u53EF\u9009\u62E9\u3002' : '\u786E\u5B9A\u8981' + actionText + '\u77E5\u8BC6\u5E93\u3010' + row.name + '\u3011\u5417\uFF1F';
      this.$confirm(message, '提示', { type: 'warning' }).then(function () {
        request.common(apiName, row.id).then(function () {
          _this3.$message.success(successText);
          _this3.onRefresh();
        });
      });
    },
    canActiveKnowledge: function canActiveKnowledge(status) {
      if (status === null || status === undefined || status === '' || status === 0) {
        return false;
      }
      return [1, 3].includes(Number(status));
    },
    getKnowledgeStatusLabel: function getKnowledgeStatusLabel(status) {
      return this.getOptionLabel('KnowledgeStatusTable', status) || '未知状态';
    },
    handleDialogClosed: function handleDialogClosed() {
      var shouldRefresh = this.refreshAfterDialogClose;
      this.refreshAfterDialogClose = false;
      this.dialogId = 0;
      this.dialogStatus = __WEBPACK_IMPORTED_MODULE_4__views_training_training_knowledge_constants__["a" /* consts */].STATUS_NEW;
      this.resetDialogForm();
      if (shouldRefresh) {
        this.onRefresh();
      }
    },
    resetDialogForm: function resetDialogForm() {
      var _this4 = this;

      this.dialogForm = {
        name: '',
        is_common: 1,
        customerid: null
      };
      this.$nextTick(function () {
        if (_this4.$refs.dialogForm) {
          _this4.$refs.dialogForm.clearValidate();
        }
      });
    },
    handleDialogIsCommonChange: function handleDialogIsCommonChange(value) {
      var _this5 = this;

      if (this.isDialogEditLocked) {
        return;
      }
      if (Number(value) === 1) {
        this.dialogForm.customerid = null;
      }
      this.$nextTick(function () {
        if (_this5.$refs.dialogForm) {
          _this5.$refs.dialogForm.clearValidate('customerid');
        }
      });
    },
    getDialogSubmitData: function getDialogSubmitData() {
      var isCommon = Number(this.dialogForm.is_common);
      return {
        id: this.dialogId,
        name: this.dialogForm.name,
        is_common: isCommon,
        customerid: isCommon === 1 ? 0 : this.dialogForm.customerid
      };
    },
    saveTrainingKnowledge: function saveTrainingKnowledge() {
      var _this6 = this;

      this.$refs.dialogForm.validate(function (valid) {
        if (!valid) {
          return;
        }
        var apiName = _this6.dialogId ? 'updateTrainingKnowledge' : 'createTrainingKnowledge';
        request.common(apiName, _this6.getDialogSubmitData()).then(function (_) {
          _this6.$message.success('保存成功');
          _this6.closeDialogRefresh();
        });
      });
    },
    getIsCommonTagClass: function getIsCommonTagClass(isCommon) {
      return Number(isCommon) === 1 ? 'knowledge-tag--success' : 'knowledge-tag--default';
    },
    getStatusTagClass: function getStatusTagClass(status) {
      if (Number(status) === this.consts.STATUS_NEW) {
        return 'knowledge-tag--primary';
      }
      if (Number(status) === this.consts.STATUS_ACTIVE) {
        return 'knowledge-tag--success';
      }
      if (Number(status) === this.consts.STATUS_BANNED) {
        return 'knowledge-tag--warning';
      }
      return 'knowledge-tag--default';
    }
  })
});

/***/ }),

/***/ 5691:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5692);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("a1365f82", content, true, {});

/***/ }),

/***/ 5692:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".knowledge-name[data-v-12637208]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;line-height:20px;color:#1f2d3d}.knowledge-name__icon[data-v-12637208]{margin-right:8px;color:#f5a623;font-size:14px}.knowledge-tag[data-v-12637208]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:48px;height:22px;padding:0 12px;border-radius:11px;-webkit-box-sizing:border-box;box-sizing:border-box;font-size:12px;line-height:22px;white-space:nowrap}.knowledge-tag--success[data-v-12637208]{color:#00a854;background-color:#d9f7e7}.knowledge-tag--default[data-v-12637208]{color:#1f2d3d;background-color:#f4f5f7}.knowledge-tag--danger[data-v-12637208]{color:#f56c6c;background-color:#fdf6ec}.knowledge-tag--primary[data-v-12637208]{color:#409eff;background-color:#ecf5ff}.knowledge-dialog__tips[data-v-12637208]{color:#8492a6;font-size:12px;line-height:20px}.knowledge-dialog__alert[data-v-12637208]{margin-bottom:16px}", "", {"version":3,"sources":["/workspace/src/views/training/pages/knowledge/TrainingKnowledgeTable.vue"],"names":[],"mappings":"AACA,iCAAiC,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,iBAAiB,aAAa,CAC1M,AACD,uCAAuC,iBAAiB,cAAc,cAAc,CACnF,AACD,gCAAgC,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,eAAe,YAAY,eAAe,mBAAmB,8BAA8B,sBAAsB,eAAe,iBAAiB,kBAAkB,CAClZ,AACD,yCAAyC,cAAc,wBAAwB,CAC9E,AACD,yCAAyC,cAAc,wBAAwB,CAC9E,AACD,wCAAwC,cAAc,wBAAwB,CAC7E,AACD,yCAAyC,cAAc,wBAAwB,CAC9E,AACD,yCAAyC,cAAc,eAAe,gBAAgB,CACrF,AACD,0CAA0C,kBAAkB,CAC3D","file":"TrainingKnowledgeTable.vue","sourcesContent":["\n.knowledge-name[data-v-12637208]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;line-height:20px;color:#1f2d3d\n}\n.knowledge-name__icon[data-v-12637208]{margin-right:8px;color:#f5a623;font-size:14px\n}\n.knowledge-tag[data-v-12637208]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:48px;height:22px;padding:0 12px;border-radius:11px;-webkit-box-sizing:border-box;box-sizing:border-box;font-size:12px;line-height:22px;white-space:nowrap\n}\n.knowledge-tag--success[data-v-12637208]{color:#00a854;background-color:#d9f7e7\n}\n.knowledge-tag--default[data-v-12637208]{color:#1f2d3d;background-color:#f4f5f7\n}\n.knowledge-tag--danger[data-v-12637208]{color:#f56c6c;background-color:#fdf6ec\n}\n.knowledge-tag--primary[data-v-12637208]{color:#409EFF;background-color:#ecf5ff\n}\n.knowledge-dialog__tips[data-v-12637208]{color:#8492a6;font-size:12px;line-height:20px\n}\n.knowledge-dialog__alert[data-v-12637208]{margin-bottom:16px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5693:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v("\n      "+_vm._s(_vm.$route.meta.title)+"\n    ")]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{path: '/'}}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("考试培训管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"label-width":"96px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"label":"知识库名称","prop":"name"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"请输入知识库名称搜索"},model:{value:(_vm.search.name),callback:function ($$v) {_vm.$set(_vm.search, "name", $$v)},expression:"search.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否通用","prop":"is_common"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择状态","clearable":""},model:{value:(_vm.search.is_common),callback:function ($$v) {_vm.$set(_vm.search, "is_common", $$v)},expression:"search.is_common"}},_vm._l((_vm.options.IsCommonStatus),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属客户","prop":"customerid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"请输入客户关键字","query-request":_vm.getCustomerTable,"find-request":_vm.getCustomerDetail},model:{value:(_vm.search.customerid),callback:function ($$v) {_vm.$set(_vm.search, "customerid", $$v)},expression:"search.customerid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"知识库状态","prop":"status"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择知识库状态","clearable":""},model:{value:(_vm.search.status),callback:function ($$v) {_vm.$set(_vm.search, "status", $$v)},expression:"search.status"}},_vm._l((_vm.options.KnowledgeStatus),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"创建人","prop":"creator_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请输入创建人","query-request":function (params){ return _vm.getPlatformUsersIndex(Object.assign(params, {usertype: [1, 2, 3, 4, 5], status_lists: [1, 2]})); },"find-request":_vm.getPlatformUsersDetail},model:{value:(_vm.search.creator_id),callback:function ($$v) {_vm.$set(_vm.search, "creator_id", $$v)},expression:"search.creator_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"创建时间","prop":"created_at"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"right","default-time":['00:00:00', '23:59:59'],"value-format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.search.created_at),callback:function ($$v) {_vm.$set(_vm.search, "created_at", $$v)},expression:"search.created_at"}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit"}},[_vm._v("搜索\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.resetSearch()}}},[_vm._v("重置")])],1)],1)],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('div',{staticClass:"margin b15"},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.createTrainingKnowledge}},[_vm._v("创建知识库\n      ")])],1),_vm._v(" "),_c('el-table',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":""}},[_c('el-table-column',{key:"id",attrs:{"prop":"id","label":"ID"}}),_vm._v(" "),_c('el-table-column',{key:"name",attrs:{"prop":"name","label":"知识库名称"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"knowledge-name"},[_c('i',{staticClass:"el-icon-folder knowledge-name__icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(scope.row.name))])])]}}])}),_vm._v(" "),_c('el-table-column',{key:"is_common",attrs:{"prop":"is_common","label":"是否通用"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"knowledge-tag",class:_vm.getIsCommonTagClass(scope.row.is_common)},[_vm._v("\n            "+_vm._s(_vm.getOptionLabel('IsCommonStatus', scope.row.is_common))+"\n          ")])]}}])}),_vm._v(" "),_c('el-table-column',{key:"customerid",attrs:{"prop":"customerid","label":"所属客户"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.customerid)?_c('span',[_vm._v(_vm._s(scope.row.customer_name))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{key:"status",attrs:{"prop":"status","label":"状态"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"knowledge-tag",class:_vm.getStatusTagClass(scope.row.status)},[_vm._v("\n            "+_vm._s(_vm.getKnowledgeStatusLabel(scope.row.status))+"\n          ")])]}}])}),_vm._v(" "),_c('el-table-column',{key:"created_at",attrs:{"prop":"created_at","label":"创建时间"}}),_vm._v(" "),_c('el-table-column',{key:"creator_id",attrs:{"prop":"creator_id","label":"创建人"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.creator_id)?_c('span',[_vm._v(_vm._s(scope.row.user_name))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{key:"operation",attrs:{"fixed":"right","label":"操作","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"primary","plain":"","size":"mini"},on:{"click":function($event){return _vm.editTrainingKnowledge(scope.row.id)}}},[_vm._v("修改\n          ")]),_vm._v(" "),(_vm.canActiveKnowledge(scope.row.status) && _vm.isSuperAdmin)?_c('el-button',{attrs:{"type":"success","plain":"","size":"mini"},on:{"click":function($event){return _vm.changeTrainingKnowledgeStatus(scope.row)}}},[_vm._v("激活\n          ")]):_vm._e(),_vm._v(" "),(Number(scope.row.status) === _vm.consts.STATUS_ACTIVE && _vm.isSuperAdmin)?_c('el-button',{attrs:{"type":"info","plain":"","size":"mini"},on:{"click":function($event){return _vm.changeTrainingKnowledgeStatus(scope.row)}}},[_vm._v("作废\n          ")]):_vm._e()]}}])})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.dialogTitle,"visible":_vm.dialogVisible,"width":"680px"},on:{"update:visible":function($event){_vm.dialogVisible=$event},"closed":_vm.handleDialogClosed}},[_c('el-form',{ref:"dialogForm",attrs:{"model":_vm.dialogForm,"rules":_vm.dialogRules,"label-width":"150px"}},[_c('el-form-item',{attrs:{"label":"知识库名称","prop":"name"}},[_c('el-input',{attrs:{"placeholder":"请输入知识库名称"},model:{value:(_vm.dialogForm.name),callback:function ($$v) {_vm.$set(_vm.dialogForm, "name", $$v)},expression:"dialogForm.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否通用","prop":"is_common"}},[_c('el-radio-group',{attrs:{"disabled":_vm.isDialogEditLocked},on:{"change":_vm.handleDialogIsCommonChange},model:{value:(_vm.dialogForm.is_common),callback:function ($$v) {_vm.$set(_vm.dialogForm, "is_common", $$v)},expression:"dialogForm.is_common"}},[_c('el-radio',{attrs:{"label":1}},[_vm._v("通用")]),_vm._v(" "),_c('el-radio',{attrs:{"label":0}},[_vm._v("专用")])],1),_vm._v(" "),_c('div',{staticClass:"knowledge-dialog__tips"},[_vm._v("通用知识库适用于所有用户，专用知识库仅适用于特定客户")])],1),_vm._v(" "),(Number(_vm.dialogForm.is_common) === 0)?_c('el-form-item',{attrs:{"label":"所属客户","prop":"customerid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"请选择客户","disabled":_vm.isDialogEditLocked,"query-request":_vm.getCustomerTable,"find-request":_vm.getCustomerDetail},model:{value:(_vm.dialogForm.customerid),callback:function ($$v) {_vm.$set(_vm.dialogForm, "customerid", $$v)},expression:"dialogForm.customerid"}})],1):_vm._e()],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":_vm.closeDialog}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.saveTrainingKnowledge}},[_vm._v("保存\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/training-knowledge.519e74f6327e14fa0f10.js